{
  "EMOJI": {
    "PLACEHOLDER": "Emojis durchsuchen",
    "NOT_FOUND": "Kein Emoji entspricht deiner Suche",
    "REMOVE": "Entfernen"
  },
  "EMOJI_ICON_PICKER": {
    "TABS": {
      "ICONS": "Icons",
      "EMOJIS": "Emojis"
    },
    "SEARCH_EMOJI": "Search emoji…",
    "SEARCH_ICON": "Search icons…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "Kein Emoji entspricht deiner Suche",
    "NO_ICON": "No icons match your search",
    "REMOVE": "Entfernen",
    "STYLE": {
      "OUTLINE": "Outline icons",
      "FILLED": "Filled icons"
    },
    "COLORS": {
      "SLATE": "Slate",
      "RED": "Red",
      "ORANGE": "Orange",
      "AMBER": "Amber",
      "GREEN": "Green",
      "TEAL": "Teal",
      "BLUE": "Blue",
      "INDIGO": "Indigo",
      "VIOLET": "Violet",
      "PINK": "Pink"
    }
  }
}
